const messages = {
  name: 'Estadisticas',
  fields: {
    accountName: 'Nombre de Cuenta',
    api: 'Api',
    lastAccess: 'Ultimo acceso',
    lastDaySuccessfulAccess: 'Accesos correctos ultimo dia',
    lastDayWrongAccess: 'Accesos erroneos ultimo dia',
    lastWeekSuccessfulAccess: 'Accesos correctos ultima semana',
    lastWeekWrongAccess: 'Accesos erroneos ultima semana',
    lastMonthSuccessfulAccess: 'Accesos correctos ultimo mes',
    lastMonthWrongAccess: 'Accesos erroneos ultimo mes',
  },
  filters: {
    accountName: 'Nombre de Cuenta',
  },
  dashboard: {
    period: 'Periodo',
    account: 'Cuenta',
    allAccounts: 'Todas las cuentas',
    kpiProcessing: 'Tiempo de proceso',
    kpiProcessingP95: 'p95 %{p95}',
    colProcessing: 'Proceso',
    colDelivery: 'Entrega',
    periodToday: 'Hoy',
    period7d: '7 dias',
    period30d: '30 dias',
    periodCustom: 'Personalizado',
    from: 'Desde',
    to: 'Hasta',
    channel: 'Canal',
    allChannels: 'Todos los canales',
    kpiSent: 'Envios',
    kpiSuccessRate: 'Tasa de exito',
    kpiFailed: 'Fallos',
    kpiActiveAccounts: 'Cuentas activas',
    deltaFlat: '▬ sin cambios',
    deltaVsPrev: 'vs. periodo anterior',
    chartTitle: 'Envios por dia y canal',
    chartSubtitle: 'Apilado por canal; el tramo rojo son los fallos del dia',
    legendFailed: 'Fallos',
    byChannelTitle: 'Por canal',
    byChannelSubtitle: 'Volumen y tasa de exito del periodo',
    topAccountsTitle: 'Top cuentas',
    topAccountsSubtitle: 'Envios por cuenta en el periodo',
    colChannel: 'Canal',
    colSent: 'Envios',
    colSuccess: 'Exito',
    colAccount: 'Cuenta',
    colRequests: 'Envios',
    colErrors: 'Errores',
    colStatus: 'Estado',
    colEndpoint: 'Endpoint',
    colErrors24h: 'Errores 24h',
    colErrorsPeriod: 'Errores del periodo',
    colOkPeriod: 'OK del periodo',
    failPct: '%{pct}% fallos',
    apiHealthTitle: 'Salud de la API',
    apiHealthSubtitle: 'Solo cuentas/endpoints con errores en el periodo',
    apiHealthEmpty: 'Sin errores de API en este periodo',
    viewApiTable: 'Ver todas las estadisticas de API →',
    hideApiTable: 'Ocultar estadisticas de API',
  },
};

export default messages;
